/*eslint-disable*/
import React from 'react';
import { BaseSelect } from 'ui-kit';
import { FAIL_OPTIONS } from '../../reducer';
import * as Styled from './styles';

const CurrentRetailersFailing = ({ handleStateForm = () => {}, stateForm = {}, type = '' }) => {
  return (
    <Styled.SubPanelSection>
      <Styled.SubPanelLabel>Failure count</Styled.SubPanelLabel>
      <BaseSelect
        name="current_retailers_failing_number"
        labelText=""
        options={FAIL_OPTIONS}
        value={stateForm[type]}
        onChange={(selectedValue) => handleStateForm({ value: selectedValue, type })}
        inputId="current_retailers_failing_number"
      />
    </Styled.SubPanelSection>
  );
};

export default CurrentRetailersFailing;
